import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/landing/HighValueV2.tsx");
